import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IconSpriteModule } from '../icon-sprite/icon-sprite.module';
import { PrIconComponent } from './pr-icon.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [PrIconComponent],
  imports: [
    CommonModule,
    MatIconModule,
    IconSpriteModule,
    TooltipModule.forRoot(),
  ],
  exports: [PrIconComponent],
})
export class PrIconModule {}
